import React from 'react';

export const Input = ({extraClasses, label, inputType, handler, blured, placeholder, value, ...props}) => {
    return (
        <div className={`formInput ${extraClasses || ''}`}>
            <label> {label} </label>
            <input type={inputType} onChange={handler} onBlur={blured} placeholder={placeholder} value={value} {...props}/>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Inputs.js